<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <Navbar />
    <div class="friends-page">
      <!-- Demandes d'ami -->
      <el-card class="friends-card" shadow="always">
        <template #header>
          <h3>Demandes d'ami</h3>
        </template>

        <el-empty v-if="friendRequests.length === 0" description="Aucune demande d'ami en cours" />

        <div v-for="request in friendRequests" :key="request.id" class="friend-row">
          <div class="friend-info">
            <el-avatar :size="40" :src="getProfilePictureUrl(request.user.profile_picture)">
              {{ request.user.username.charAt(0).toUpperCase() }}
            </el-avatar>
            <span class="friend-name"><UserLink :username="request.user.username" /></span>
          </div>
          <div class="friend-actions">
            <el-button type="success" size="small" @click="acceptFriendRequest(request.user.id)">
              Accepter
            </el-button>
            <el-button type="danger" size="small" @click="rejectFriendRequest(request.user.id)">
              Refuser
            </el-button>
          </div>
        </div>
      </el-card>

      <!-- Liste d'amis -->
      <el-card class="friends-card" shadow="always">
        <template #header>
          <h3>Liste d'amis</h3>
        </template>

        <el-empty v-if="sessionFriends.length === 0" description="Votre liste d'amis est vide" />

        <div v-for="friend in sessionFriends" :key="friend.id" class="friend-row">
          <div class="friend-info">
            <el-avatar :size="40" :src="getProfilePictureUrl(friend.user.profile_picture)">
              {{ friend.user.username.charAt(0).toUpperCase() }}
            </el-avatar>
            <span class="friend-name"><UserLink :username="friend.user.username" /></span>
          </div>
          <div class="friend-actions">
            <el-button type="danger" size="small" @click="rejectFriendRequest(friend.user.id)">
              Supprimer
            </el-button>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import UserLink from '@/components/UserLink.vue'
import api, { API_BASE_URL } from '@/api';
import { notifySuccess, notifyError } from '@/notify'

export default {
  components: {
    Navbar,
    UserLink,
  },

  data() {
    return {
      friendRequests: [],
      sessionFriends: [],
    }
  },

  mounted() {
    this.getFriendRequests()
    this.getSessionFriends()
    document.body.style.backgroundColor = 'rgba(21, 109, 123)'
  },

  methods: {
    getProfilePictureUrl(profilePicturePath) {
      return `${API_BASE_URL}/${profilePicturePath}`
    },

    async getFriendRequests() {
      try {
        const response = await api.get('/friend/FriendRequest', {
          withCredentials: true,
        })
        this.friendRequests = response.data.friendRequests
      } catch (error) {
        console.error(error)
      }
    },

    async getSessionFriends() {
      try {
        const response = await api.get('/friend/sessionFriends', {
          withCredentials: true,
        })
        this.sessionFriends = response.data.sessionFriends
      } catch (error) {
        console.error(error)
      }
    },

    async acceptFriendRequest(friendRequestId) {
      try {
        await api.post(
          '/friend/acceptRequest',
          { friendId: friendRequestId },
          { withCredentials: true }
        )
        notifySuccess("Demande d'ami acceptée")
        this.getFriendRequests()
        this.getSessionFriends()
      } catch (error) {
        console.error(error)
        notifyError(error, "Impossible d'accepter la demande")
      }
    },

    async rejectFriendRequest(friendRequestId) {
      try {
        await api.post(
          '/friend/rejectRequest',
          { friendId: friendRequestId },
          { withCredentials: true }
        )
        notifySuccess("Demande d'ami refusée")
        this.getFriendRequests()
        this.getSessionFriends()
      } catch (error) {
        console.error(error)
        notifyError(error, 'Impossible de refuser la demande')
      }
    },
  },
}
</script>

<style scoped>
.friends-page {
  padding: 70px 20px 20px;
  max-width: 700px;
  margin: 0 auto;
}

.friends-card {
  margin-bottom: 20px;
}

.friends-card h3 {
  margin: 0;
  color: #303133;
}

.friend-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.friend-row:last-child {
  border-bottom: none;
}

.friend-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.friend-name {
  font-weight: 500;
  color: #303133;
}

.friend-actions {
  display: flex;
  gap: 8px;
}
</style>
